import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
var ScrollMagic
if (typeof window === 'object') {
    ScrollMagic = require('scrollmagic')
}

import CustomHelmet from '../components/CustomHelmet'
import ApplyInterest from '../components/Apply-Interest'
import Afterhero from '../components/Program/Afterhero'
import Destinations from '../components/Program/Destinations'
import VimeoEmbed from '../components/Shared/VimeoEmbed'
import Hero from '../components/Program/Hero'


import Row from '../components/Shared/Row'
import Column from '../components/Shared/Column'


// if(typeof window == 'object') {
// 	require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
// }

class ApprenticeshipTempTemplate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeNav: '',
            controller: null
        }
    }

    componentDidMount() {}
	componentWillUnmount() {}
    render() {
        const { data: { page },  } = this.props;
        const seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : ``;
        const pageData = this.props.pathContext.data

        return (
            <div className="apprenticeship">
                <CustomHelmet data={ page.seoData } />
                <Hero
                    title={pageData.introTitle}
                    src={pageData.heroImage}
                />
                <Afterhero
                    text={ pageData.introduction.internal.content }
                />
                {
                    pageData.pastStories && pageData.pastStories.map( (story,index) => (
                        <Row className={ `example${index > 0 ? ' no-padding-top' : '' }` } key={ index }>
                            <Column width="12" className="capped">
                                {
                                    story.fellowHeadshot && story.fellowHeadshot.file.url &&
                                    <img src={ story.fellowHeadshot.file.url } alt="" className="fellow-headshot" />
                                }
                                {
                                    story.videoUrl &&
                                    <Row className="no-padding">
                                        <Column width="4" tablet="12" className="details">
                                            <h3>{ story.fellowDetail }</h3>
                                        </Column>
                                        <Column width="7" offsetL="1" tablet="12" className="quote">
                                            <VimeoEmbed
                                              poster={ story.videoPosterImage }
                                              url={ story.videoUrl }
                                              loop={false}
                                              autoplay={false}
                                              controls={true}
                                            />
                                        </Column>
                                    </Row>
                                }
                                {
                                    !story.videoUrl &&
                                    <Row className="no-padding">
                                        <Column width="6" tablet="12" className="details">
                                            <h3>{ story.fellowDetail }</h3>
                                        </Column>
                                        <Column width="6" tablet="12" className="quote">
                                            <p>{ story.fellowQuote.fellowQuote }</p>
                                        </Column>
                                        <Column width="12" className="link">
                                            <a href={ story.link.link } className="hoverlink" target="_blank">{ story.linkText }</a>
                                        </Column>
                                    </Row>
                                }
                            </Column>
                            {
                                index == 1 &&
                                <div className="strokes">
                                  <img className="Strokes__Blue" src="/images/blue-strokes.png" alt="Blue stroke" />
                                </div>
                            }
                        </Row>
                    ))
                }
                <ApplyInterest
                    title={page.applyTitle}
                />
            </div>
        );
    }
}

export default ApprenticeshipTempTemplate

export const query = graphql`
  query ApprenticeshipTempTemplatePageQuery {
    page: contentfulProgramPage {
      title
      heroImage {
          sizes(quality:100, maxWidth:1200) {
              ...GatsbyContentfulSizes_withWebp
          }
        title
        file {
          url
          fileName
          contentType
        }
      }
      applyTitle
      seoData {
        id
        pageTitle
        pageDescription {
          id
          pageDescription
        }
        keywords
        openGraphTitle
        openGraphDescription {
          id
          openGraphDescription
        }
        openGraphImage {
          id
          file {
            url
            fileName
            contentType
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/apprenticeship.js